<template>
  <MatchMedia query="(max-width: 760px)" v-slot="{ matches }">
    <EntryShowMobile  v-if="matches" />
    <EntryShowDesktop v-else />
  </MatchMedia>
</template>
 
<script>
  import { MatchMedia } from "vue-component-media-queries";
  import EntryShowMobile from "./EntryShow_Mobile.vue";
  import EntryShowDesktop from "./EntryShow_Desktop.vue";
 
  export default {
    name: 'Desktop',
    components: {
      MatchMedia,
      EntryShowMobile,
      EntryShowDesktop,
    },
  }
</script> 